<template>
  <j-modal
    :title="title"
    width="25%"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    :body-style="{ height: '380px', overflow: 'hidden', overflowY: 'scroll' }"
    @ok="handleOk"
    @cancel="handleCancel"
    :okText="$t('确定')"
    :cancelText="$t('关闭')"
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
  >
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model
          ref="form"
          :model="model"
          :rules="validatorRules"
          slot="detail"
          :colon="true"
          layout="horizontal"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item :label="$t('项目编码')">
                <a-input v-model="model.projectCode" disabled></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('分区编码')">
                <a-input v-model="model.code" disabled></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('分区名称')" prop="name">
                <a-input v-model="model.name" :placeholder="$t('请输入分区名称')"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>
  
  <script>
import { httpAction, getAction, postAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
export default {
  name: 'modal',
  components: {},
  data() {
    return {
      width: 800,
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      model: {},
      labelCol: { span: 5 },
      wrapperCol: { span: 19 },
      url: {
        edit: '/jeecg-gis/area/edit',
      },
    }
  },
  computed: {
    title() {
      return this.$t('编辑')
    },
    validatorRules() {
      return {
        name: [{ required: true, message: this.$t('请输入分区名称') }],
      }
    },
  },
  methods: {
    init(row) {
      this.visible = true
      this.model = JSON.parse(JSON.stringify(row))
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
    handleOk() {
      const that = this
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true
          postAction(this.url.edit, this.model)
            .then(res => {
              if (res.success) {
                that.$message.success(this.$t('编辑成功！'))
                that.$emit('ok')
                this.visible = false
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },
  },
}
</script>